
import jquery from 'jquery';
window.jQuery = window.$ = jquery;
  //slickslider
import 'slick-carousel'

$('.logo-slider').slick({
  infinite: false,
  accessibility: true,
  speed: 300,
  arrow: false,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.news-slider').slick({
  infinite: false,
  speed: 300,
  accessibility: true,
  slidesToShow: 3,
  slidesToScroll:3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
});


$('.news-slider-images').slick({
  infinite: true,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll:1,
});




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/Js/components/slickslider/slickslider.js
 **/